export default __webpack_public_path__ + "static/media/dashboardBanner.f0fa4112.png";